import React, { useState } from 'react';
import { Breadcrumb, Col, Layout, Menu, Row } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Calendar from 'react-awesome-calendar';
import { DashboardOutlined, DashboardFilled, VideoCameraOutlined, PlusOutlined, BellOutlined, MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';

import ImageComponent from '@sharedComponent/image-component';
import { HomeRoutes } from 'src/routes';
import ProjectMenus from './project-menu/project-menu';
import ReporterMenus from './reporterMenu';
import ButtonComponent from '@sharedComponent/button';
import camelcase from 'camelcase';
import { images } from '@assets/img'

const { Header, Content, Footer, Sider } = Layout;

const menus = [
	{
		name: 'Dashboard',
		Icon: <DashboardFilled />,
		route: '/',
	},
	{
		name: 'Patients',
		Icon: <VideoCameraOutlined />,
		route: '/patients',
	},
	{
		name: 'Appointments',
		Icon: <VideoCameraOutlined />,
		route: '/appointments',
	}
];

const members_list = [
	{
		name: 'Ashiq',
		image:
			'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/5e69beef7d64450d01a7982d/0ef6bd2b-e8db-4621-a534-60726e1fccf3/48',
	},
	{
		name: 'Derek',
		image:
			'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/5cc08306174d2a0e4b04a347/25040fd5-047b-4b2f-b67e-d63724b617ad/48',
	},
	{
		name: 'Sathish',
		image:
			'https://secure.gravatar.com/avatar/e55c484d86abe1b736c1c401a98cf940?d=https%3A%2F%2Favatar-management--avatars.us-west-2.prod.public.atl-paas.net%2Finitials%2FSS-1.png',
	},
];

const activity_list = [
	{
		time: '2 min ago',
		name: 'Ashiq',
		desc: 'Setting up a database and data integration',
		image:
			'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/5e69beef7d64450d01a7982d/0ef6bd2b-e8db-4621-a534-60726e1fccf3/48',
	},
	{
		time: '12 Aug, Thu',
		name: 'Sathish',
		desc: 'Dashboard Page design',
		image:
			'https://secure.gravatar.com/avatar/e55c484d86abe1b736c1c401a98cf940?d=https%3A%2F%2Favatar-management--avatars.us-west-2.prod.public.atl-paas.net%2Finitials%2FSS-1.png',
	},
	{
		time: '2 min ago',
		name: 'Ashiq',
		desc: 'Setting up a database and data integration',
		image:
			'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/5e69beef7d64450d01a7982d/0ef6bd2b-e8db-4621-a534-60726e1fccf3/48',
	},
	{
		time: '12 Aug, Thu',
		name: 'Sathish',
		desc: 'Dashboard Page design',
		image:
			'https://secure.gravatar.com/avatar/e55c484d86abe1b736c1c401a98cf940?d=https%3A%2F%2Favatar-management--avatars.us-west-2.prod.public.atl-paas.net%2Finitials%2FSS-1.png',
	},
	{
		time: '2 min ago',
		name: 'Ashiq',
		desc: 'Setting up a database and data integration',
		image:
			'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/5e69beef7d64450d01a7982d/0ef6bd2b-e8db-4621-a534-60726e1fccf3/48',
	},
	{
		time: '12 Aug, Thu',
		name: 'Sathish',
		desc: 'Dashboard Page design',
		image:
			'https://secure.gravatar.com/avatar/e55c484d86abe1b736c1c401a98cf940?d=https%3A%2F%2Favatar-management--avatars.us-west-2.prod.public.atl-paas.net%2Finitials%2FSS-1.png',
	},
];



const MainLayoutPresentational = (props) => {
	const [viewdetails, setViewdetails] = useState(true);
	const [collapsed, setCollapsed] = useState(false);

	const toggle = () => {
		setCollapsed(!collapsed)
	};
	const events = [{
		id: 1,
		color: '#fd3153',
		from: '2021-06-02T18:00:00+00:00',
		to: '2021-06-05T19:00:00+00:00',
		title: 'This is an event'
	}, {
		id: 2,
		color: '#1ccb9e',
		from: '2021-06-07T13:00:00+00:00',
		to: '2021-06-07T14:00:00+00:00',
		title: 'This is another event'
	}, {
		id: 3,
		color: '#3694DF',
		from: '2019-06-01T13:00:00+00:00',
		to: '2019-06-01T20:00:00+00:00',
		title: 'This is also another event'
	}];
	return (
		<Layout>
			<Layout className="site-layout">
				<Header className="site-layout-background" style={{ padding: 0, minHeight: '70px', boxShadow: '0 0 5px 3px #ddd' }}>
					<Row align={'middle'} style={{ boxShadow: '0 0 5px 3px #ddd' }}>
						<Col md={6}>
						</Col>
						<Col md={6}>
						</Col>
						<Col md={6}>
						</Col>
						<Col md={6} style={{ textAlign: 'right', borderLeft: '1px solid #ddd', paddingLeft: '30px' }}>
							<span className='headerAvathar_2'>
								<img src={images.bellRing} />
							</span>
							<span className='headerAvathar_1' style={{ paddingRight: '15px' }}>
								<img src={images.doctorIcon} />
							</span>
						</Col>
					</Row>
				</Header>
				<Content className="site-layout-background" style={{
					padding: 15,
					minHeight: 'calc(100vh - 70px)',
					overflow: 'auto',
					maxHeight: 'calc(100vh - 70px)',
					backgroundColor: '#ecf1f7'

				}}>
					<Row>
						<Col xs={24} sm={24} md={24} lg={24} xl={24}>
							<HomeRoutes />
						</Col>
					</Row>
				</Content>
			</Layout>
		</Layout >
	);
};

export default MainLayoutPresentational;
